import { useEffect } from "react";

import { useMapContext } from "hooks/useMapContext";
import { useMap } from "react-leaflet";
/**
 * A component whose sole purpose is to lift the map to a custom context
 * The map variable (const map = useMap()) can only be obtained if you are within context of
 * a leaflet map. However, we have to work with the map elsewhere in the app as well. That's why
 * it is lifted to a custom context (useMapContext() hook)
 */
export const ContextLifter = () => {
  const map = useMap();
  const { setMap: setLiftedContextMap } = useMapContext();

  useEffect(() => {
    if (map) setLiftedContextMap(map);
    return () => setLiftedContextMap(null);
  }, [map, setLiftedContextMap]);

  return null;
};
